import { Header } from './header';

export class LayoutFixes {
    public static setupLayoutFixes() {
        const MAX_WIDGET_LOADING_WAIT = 2000;
        const WIDGET_AWAIT_TRIGGER_INTERVAL = 1000;

        $(window).on('resize', this.onWindowResize)
            .trigger('resize');

        const widgetsTempInterFix = setInterval(() => {
            $(window).trigger('resize');
        }, WIDGET_AWAIT_TRIGGER_INTERVAL);

        setTimeout(() => {
            clearInterval(widgetsTempInterFix);
        }, MAX_WIDGET_LOADING_WAIT);
    }

    private static onWindowResize() {
        Header.calculateResponsiveCenterSlot();
    }
}
